/**
 * OMR Student ID Component
 * Renders an 11×10 grid of bubbles for student CPF (11 digits)
 * Each digit (0-10) × options (0-9) = 110 bubbles
 */

import React from 'react';
import { getStudentIdGridPositions } from '../../utils/omr/geometryCalc';
import {
  STUDENT_ID_START_Y_MM,
  STUDENT_ID_DIGITS,
  STUDENT_ID_OPTIONS,
  ID_BUBBLE_DIAMETER_MM,
} from '../../utils/omr/constants';

const OMRStudentId = () => {
  const positions = getStudentIdGridPositions(STUDENT_ID_START_Y_MM);

  return (
    <div className="omr-student-id">
      {/* Label */}
      <div
        style={{
          position: 'absolute',
          left: '15mm',
          top: `${STUDENT_ID_START_Y_MM - 5}mm`,
          fontSize: '10pt',
          fontWeight: 'bold',
        }}
      >
        CPF:
      </div>

      {/* Digit labels (0-4) */}
      {Array.from({ length: STUDENT_ID_DIGITS }).map((_, digit) => (
        <div
          key={`digit-label-${digit}`}
          style={{
            position: 'absolute',
            left: `${positions[digit * STUDENT_ID_OPTIONS].x}mm`,
            top: `${STUDENT_ID_START_Y_MM - 4}mm`,
            width: `${ID_BUBBLE_DIAMETER_MM}mm`,
            textAlign: 'center',
            fontSize: '8pt',
            fontWeight: 'bold',
          }}
        >
          {digit}
        </div>
      ))}

      {/* Option labels (0-9) on the left */}
      {Array.from({ length: STUDENT_ID_OPTIONS }).map((_, option) => (
        <div
          key={`option-label-${option}`}
          style={{
            position: 'absolute',
            left: `10mm`,
            top: `${positions[option].y}mm`,
            width: '4mm',
            textAlign: 'right',
            fontSize: '7pt',
            fontWeight: 'bold',
          }}
        >
          {option}
        </div>
      ))}

      {/* Bubbles */}
      {positions.map((pos) => (
        <div
          key={`bubble-${pos.digit}-${pos.option}`}
          style={{
            position: 'absolute',
            left: `${pos.x}mm`,
            top: `${pos.y}mm`,
            width: `${pos.diameter}mm`,
            height: `${pos.diameter}mm`,
            border: '0.5pt solid #000000',
            borderRadius: '50%',
            backgroundColor: '#FFFFFF',
          }}
          className="omr-bubble-student-id"
          data-testid={`student-id-bubble-${pos.digit}-${pos.option}`}
        />
      ))}
    </div>
  );
};

export default OMRStudentId;
